{
	"transactionCardHeader": "Potvrďte transakci",
	"transactionCardDescriptionBold": "Chcete ověřit transakci pro jakýkoli projekt?",
	"transactionCardDescriptionRegular": "Pokud máte po ruce číslo transakce, můžete ho zadat zde a transakci potvrdit.",
	"showTransactionButton": "Zobrazit transakci",
	"transactionLabel": "Číslo transakce",
	"errors": {
		"transactionIdRequired": "Číslo transakce je povinné.",
		"transactionNotFound": "Nebyla nalezena žádná transakce.",
		"transactionIdInvalid": "Neplatné číslo transakce."
	}
}
